/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-fragments */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Fastfood';
import ReceiptIcon from '@material-ui/icons/Receipt';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

function createData(name, calories, category, carbs, protein, price) {
  return {
    name,
    calories,
    category,
    carbs,
    protein,
    price,
    history: [
      { date: '2020-01-05', customerId: 'Mr. Cheng', amount: 3 },
      { date: '2020-01-02', customerId: 'Jonathon', amount: 1 },
    ],
  };
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => console.log('Opened')}
          >
            {row.name === 'subtotal' ? <ReceiptIcon /> : <DeleteIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name === 'subtotal' ? (
            <>
              {' '}
              {row.name.slice(0, 8)} <br /> tax 8% <br /> <b>total</b>
            </>
          ) : (
            <b>{row.name}</b>
          )}
          <br />
          {row.name === 'subtotal' ? (
            <> {row.category.slice(2)} </>
          ) : (
            <>{row.category} </>
          )}
        </TableCell>
        <TableCell align="right">
          {row.calories === '$10.80' ? (
            <>
              {' '}
              {row.calories} <br /> $0.86 <br /> <b>$11.66 </b>
            </>
          ) : (
            <> {row.calories} </>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                History
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell align="right">Amount</TableCell>
                    <TableCell align="right">Total price ($)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.history.map((historyRow) => (
                    <TableRow key={historyRow.date}>
                      <TableCell component="th" scope="row">
                        {historyRow.date}
                      </TableCell>
                      <TableCell>{historyRow.customerId}</TableCell>
                      <TableCell align="right">{historyRow.amount}</TableCell>
                      <TableCell align="right">
                        {Math.round(historyRow.amount * row.price * 100) / 100}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.any.isRequired,
    carbs: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

const rows = [
  createData('Spring Roll', '$1.50', 'Demo Menu -> Appetizers', 24, 4.0, 3.99),
  createData(
    'Fried Chicken Wings',
    '$6.75',
    'Demo Menu -> Wings',
    37,
    4.3,
    4.99
  ),
  createData('Wonton Soup', '$2.50', 'Demo Menu -> Soup', 24, 6.0, 3.79),
  createData('subtotal', '$10.80', '', 24, 6.0, 3.79),
];

export default function CollapsibleTable() {
  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableBody>
            {rows.map((row) => (
              <Row key={row.name} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
